
import { poirotApi, krakenApi, refreshToken,tokenApi } from "../config/http-common";
import documentData from "../types/document.type";
import axios from "axios";
import qs from "qs";
import documentChallengeData from "../types/documentChallenge.type";
import { Config } from "@testing-library/react";

type GetToken = {
    token: string;
};

const cabecera = {
  
    headers: {
      'Accept': '*/*',
      'Authorization': `Bearer ${localStorage.getItem('token')}`,
      "Content-Type": "application/json",
   }
}
class DocumentsService {

    uploadDocument(data: documentData, costumerId: string) {

        return poirotApi.post<documentData>(`/my/images/otc/${costumerId}`, data, cabecera);
    }

    checkStatus(costumerId: string, type: string) {
        return poirotApi.get<documentData>(`/my/images/otc/${costumerId}?imageType=${type}`,cabecera);
    }
    
    generateToken(){
        async function getToken() {
            try {
            const { data } = await axios.post<GetToken>(
                tokenApi+'/oauth2/token',
                qs.stringify({ grant_type: 'refresh_token', refresh_token:refreshToken}),
                {
                headers: {
                    Accept: '*/*',
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
                    'Access-Control-Allow-Headers': 'Content-Type'
                },
                },
            );
                localStorage.setItem('token', data.token);
                return data.token;
            } catch (error) {
            if (axios.isAxiosError(error)) {
                console.log('error message: ', error.message);
                return false;
            } else {
                console.log('unexpected error: ', error);
                return false;
            }
            }
        }
        
        return getToken()
    }
    nextChallenge(data: documentChallengeData) {
        return krakenApi.post<documentChallengeData>(`/enrolment/challengeRespond`, data);
    }
}

export default new DocumentsService();